import axios from 'axios';
import SLS_SEND from '../service/tracker';
import { SLS_LOGIN_TYPE } from '@/common';
import { base64Encode, AuthStorage } from '@/common/utils';
const { VUE_APP_API_BASE_URL } = process.env;

const instance = axios.create({
  baseURL: VUE_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.response.use(
  function (response) {
    return response?.data || {};
  },
  function (error) {
    const { msg, code, detail, data } = error.response.data;
    return Promise.reject({ msg, code, detail, data });
  },
);

instance.interceptors.request.use((config) => {
  config = config || {};
  const params = config.params || {};
  config.params = {
    pt: 'Web',
    sdkVer: '6',
    did: AuthStorage.get('device_id') || '0',
    clientId: AuthStorage.get('xd_client_id'),
    sdkLang: AuthStorage.get('query_lang'),
    ...params,
  };

  return config;
});

export function sms_regions() {
  return instance.get('/api/login/v1/sms/regions');
}

/* 发送验证码 -v2
 * @param {Object} options
 * @param {String} options.phoneNumber
 * @param {Object} options.risk
 * @param {String|null} [options.areaCode=null]
 * @param {'SMS'|'EMAIL'|null} [params.type = null]
 */
export function code_send({ phoneNumber, email, risk, areaCode = null, type = null, riskString = '' }) {
  //v1: /api/login/v1/verification/code/send
  //v2: /api/login/v2/login/verification/code/send
  const options = {};
  // Risk-Authenticate-Sig
  if (risk) {
    const { sig, sessionId, token, appkey, scene } = risk;
    options.headers = {
      'Risk-Authenticate-Sig': JSON.stringify({
        Token: token,
        Sig: sig,
        SessionId: sessionId,
        Scene: scene,
        AppKey: appkey,
      }),
    };
  }
  if (riskString) {
    options.headers = {
      'Risk-Authenticate-Sig': base64Encode(riskString),
    };
  }
  const optionalData = {};
  areaCode && (optionalData.areaCode = areaCode);
  type && (optionalData.type = type);
  return instance.post(
    // "/api/login/v2/login/verification/code/send",
    '/api/login/v1/verification/code/send',
    {
      phoneNumber,
      email,
      ...optionalData,
    },
    options,
  );
}

/* 登录 */
// api/login/v1/union
export async function login_union(body) {
  try {
    const res = await instance.post('/api/login/v1/union', body);
    // 埋点 -手机验证码校验通过
    if (body.type === 11 && body.subType === 'text') {
      SLS_SEND.sdklogin_mobile_code_success();
    }
    // 埋点 -登录成功
    SLS_SEND.sdklogin_pre_login_success(SLS_LOGIN_TYPE.phone);
    return res;
  } catch (error) {
    // 埋点 -触发登录风控成功
    if (error?.code === 40101 || error?.code === 42900) {
      SLS_SEND.sdklogin_risk_success(error?.msg || error?.detail || '触发登录风控成功', body?.subType);
    }
    // 埋点 -验证码校验失败
    if (error?.code === 40114) {
      SLS_SEND.sdklogin_mobile_code_fail(error?.msg || error?.detail || '验证码校验失败');
    }
    // 埋点 -登录失败
    SLS_SEND.sdklogin_pre_login_fail(error?.msg || error?.detail || '登录失败');
    throw error;
  }
}

/* 获取协议链接 */
// https://test-xdsdk-6.xd.cn/api/init/v1/agreement?clientId=d4bjgwom9zk84wk
// api/init/v1/agreement?clientId=d4bjgwom9zk84wk
export function get_agreement(clientId, countryCode) {
  const params = { countryCode };
  if (clientId) {
    params.clientId = clientId;
  }
  return instance.get('api/init/v1/agreement', {
    params,
  });
}

export function getCaptchaConfig(clientId, captchaScene) {
  return instance.get('api/captcha/v1/config', {
    params: { clientId, captchaScene },
  });
}

/* 调用回环地址 */
export function pc_callback(address, params) {
  return instance.get(address, { params });
}
